import { apiPath } from './api.path';
import { instance } from './axios';

async function dashboardAPI(params) {
  return instance.get(apiPath.dashboard, params).then((response) => response.data);
}

async function getEnquiryAPI(params) {
  return instance.get(apiPath.getEnquiry, params).then((response) => response.data);
}

async function getStaticPagesAPI(params) {
  return instance.get(apiPath.getStaticPages, params).then((response) => response.data);
}

async function deletetUserAPI(params) {
  return instance.delete(apiPath.deleteUser + params._id).then((response) => response.data);
}

const dashboardService = {
  dashboardAPI,
  getEnquiryAPI,
  getStaticPagesAPI,
  deletetUserAPI
};
export default dashboardService;
